import { ButtonList, DropdownButtonContext } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { useModal } from 'lib-knowledge-modal';

import { CollectionDeleteModal } from '../modals/collectionDeleteModal';
import { CollectionEditModal } from '../modals/collectionEditModal';
import styles from './dropdownContext.module.scss';

type ToggleDropdown = {
  toggleDropdown: () => void;
  event: React.MouseEvent<HTMLOrSVGElement, MouseEvent>;
};
type DropdownContentProps = {
  collectionId: string;
  collectionTitle: string;
  isSyncedWithElevio: boolean;
};
export function DropdownContent({
  collectionId,
  collectionTitle,
  isSyncedWithElevio,
}: DropdownContentProps): JSX.Element {
  const { showModal } = useModal();

  const onEditCollection = ({ toggleDropdown, event: e }: ToggleDropdown) => {
    e.preventDefault();
    e.stopPropagation();
    if (collectionId) {
      showModal(CollectionDeleteModal, {
        collectionId,
        collectionTitle,
      });
      toggleDropdown();
    }
  };

  const onLinkCollection = ({ toggleDropdown, event: e }: ToggleDropdown) => {
    e.preventDefault();
    e.stopPropagation();
    if (collectionId) {
      showModal(CollectionEditModal, { collectionId, isSyncedWithElevio });
      toggleDropdown();
    }
  };

  return (
    <div>
      <DropdownButtonContext.Consumer>
        {({ toggleDropdown }) => (
          <ButtonList>
            <ButtonList.Item
              icon="pen"
              onClick={(e) => onLinkCollection({ toggleDropdown, event: e })}
              className={styles.buttonListItem}
            >
              Edit collection
            </ButtonList.Item>

            <ButtonList.Item
              icon="trash"
              onClick={(e) => onEditCollection({ toggleDropdown, event: e })}
              className={cx(styles.buttonListItem, styles.deleteItem)}
            >
              Delete collection
            </ButtonList.Item>
          </ButtonList>
        )}
      </DropdownButtonContext.Consumer>
    </div>
  );
}
